import React from 'react';
import { Container } from './components/styles';
import { useSponsoredBrands } from '../../hooks';
import { SponsoredBrandItem } from './components/sponsored-brand-item';
import { useInVisualViewport } from 'common/hooks';

interface BrandsProps {
  searchQuery: string;
}

export const Brands = ({ searchQuery }: BrandsProps) => {
  const { itemsToDisplay } = useSponsoredBrands();

  const { containerRef, isInViewport } = useInVisualViewport({ threshold: 0.8 });

  if (!itemsToDisplay.length) return null;

  return (
    <Container ref={containerRef}>
      {itemsToDisplay.map(({ banner, id }) => (
        <SponsoredBrandItem
          key={id}
          brand={banner}
          id={id}
          searchQuery={searchQuery}
          isInViewport={isInViewport}
        />
      ))}
    </Container>
  );
};
